/**
 * Converts a duration in milliseconds to a human-readable string.
 * e.g. 3661000 -> "1h 1m", 45000 -> "45s", 90061000 -> "1d 1h 1m"
 */
function humanizeDuration(ms: number): string {
  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  const parts: string[] = []

  if (days > 0) parts.push(`${days}d`)
  if (hours % 24 > 0) parts.push(`${hours % 24}h`)
  if (minutes % 60 > 0) parts.push(`${minutes % 60}m`)
  if (parts.length === 0) parts.push(`${seconds}s`)

  return parts.join(' ')
}

export { humanizeDuration }
